import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import DashboardTable from "../../../components/dashboard-layout/table/DashboardTable";
import { columnsTransactions } from "./tableConfig";
import { Context } from "../../../Context";
import { getWalletMovements } from "../../../services/wallets.service";

export default function TransporterTransactions({ dateRange }) {
  const { currentUser } = useContext(Context);
  const params = useParams();
  const [clientTransactions, setClientTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [searchBarActiveVal, setSearchBarActiveVal] = useState("");
  const onChangeSearchBar = (e) => {
    setSearchBarActiveVal(e.target.value);
  };
  const onGetClientTransactions = async (pag) => {
    setLoading(true);
    try {
      const response =
        currentUser.type === "SUPER_ADMIN"
          ? await getWalletMovements({
              page: pag.page,
              itemsPerPage: pag.pageSize,
              dateInitSearch: dateRange[0],
              dateEndSearch: dateRange[1],
              ownerId: parseInt(params.id),
              ownerType: "DRIVER",
              includeComissionsMovs: true,
              includeAdvance: true,
              includeBuyProduct: true,
            })
          : await getWalletMovements({
              page: pag.page,
              itemsPerPage: pag.pageSize,
              dateInitSearch: dateRange[0],
              dateEndSearch: dateRange[1],
              driverId: parseInt(params.id),
              includeComissionsMovs: true,
              includeAdvance: true,
              includeBuyProduct: true,
            });
      const responseFormatted = response.data.result.data.map((elm) => ({
        id: elm?.TransactionId || "-",
        manifestNumber: elm?.manifestNumber || "-",
        date: moment(elm?.createdAt).format("MMM DD, YYYY  hh:mm a") || "-",
        mount: `$ ${new Intl.NumberFormat("de-DE").format(elm?.value)}`,

        driverPhoto: elm?.urlProfileImage,
        product:
          `${elm?.productName}` || `${elm?.manifestNumber}` || `Transferencia`,
        organization: getDestination(elm) || "-",
      }));
      setClientTransactions(responseFormatted);
      setPagination((pagination) => ({
        ...pagination,
        page: response.data.result.pagination.currentPage,
        total: response.data.result.pagination.total,
      }));
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => onGetClientTransactions(pagination), 400);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBarActiveVal]);

  useEffect(() => {
    onGetClientTransactions(pagination);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.pageSize, dateRange]);

  const getDestination = (elm) => {
    if (elm?.type === "TRANSFER" || elm?.type === "WITHDRAWAL_MONEY") {
      return elm?.value > 0
        ? `${elm?.origin?.firstName} ${elm?.origin?.lastName}`
        : `${elm?.destination?.firstName} ${elm?.destination?.lastName}`;
    } else if (elm?.type === "ADVANCE" || elm?.type === "BUY_PRODUCT") {
      return elm?.value > 0
        ? `${elm?.origin?.name}`
        : `${elm?.destination?.name}`;
    } else {
      return "EFECTY";
    }
  };

  const onChangePage = (val) => {
    setPagination((pagination) => ({ ...pagination, page: val }));
  };

  const onChangeItemsPerPage = (index, val) => {
    setPagination((pagination) => ({ ...pagination, pageSize: val }));
  };
  return (
    <>
      <DashboardTable
        columns={columnsTransactions}
        tableTitle={`Total de Transacciones: ${pagination.total}`}
        data={clientTransactions}
        customButton={null}
        pagination={pagination}
        page={pagination.page}
        rowKey="key"
        loading={loading}
        onChangeSearchBar={onChangeSearchBar}
        onChangePage={onChangePage}
        onChangeItemsPerPage={onChangeItemsPerPage}
      />
    </>
  );
}
